import projectConfig from '../config'

// plugins
import i18n from "./modules/i18n";
import vuetify from "./modules/vuetify";

export default {
  install: (app: App) => {
    // load config
    app.config.globalProperties.project = projectConfig

    // load plugins
    app.use(i18n)
    app.use(vuetify)
  }
}
